function escapeRegExp(s: string) {
  return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

/**
 * Highlights matching text in a string based on a query.
 * @param text - The text to highlight
 * @param query - The search query to highlight
 * @returns JSX elements with highlighted matching text
 */
export function highlightText(text: string, query: string) {
  if (!query) return text;
  const regex = new RegExp(`(${escapeRegExp(query)})`, "gi");
  const parts = text.split(regex);
  const isMatch = new RegExp(`^${escapeRegExp(query)}$`, "i");
  return parts
    .filter(Boolean)
    .map((part, index) =>
      isMatch.test(part) ? (
        <span key={index} className="font-semibold underline">
          {part}
        </span>
      ) : (
        <span key={index} className="font-normal text-default-500">
          {part}
        </span>
      )
    );
}
